import { CallbackWrap } from '@/types/common'
import { Embed, SkillsEmbed } from '@/types/embed'
import { LevelingEmbed, LevelingEmbedRef } from '@/types/leveling'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TabsBox } from '@maxroll-media-group/common-libs'
import { RichTextEditor } from 'components/editor/rich-text-editor/RichTextEditor'
import SkillGems from 'components/embeds/SkillGems'
import React from 'react'
import { EmbedRef, WithStore } from '../../common'

export function LevelingSkills({
  embed,
  onEmbedChange,
  isActiveTab,
  skillsStep,
  activeSkills
}: {
  embed: LevelingEmbed
  onEmbedChange?: (value: CallbackWrap<Embed>) => void
  isActiveTab?: boolean
  skillsStep:
    | {
        level: number
        ref: LevelingEmbedRef
      }
    | undefined
  activeSkills:
    | EmbedRef<
        SkillsEmbed & {
          type: 'skills' | 'skills-video-display'
        }
      >
    | undefined
}) {
  const [isEditingSkillGemsDesc, setIsEditingSkillGemsDesc] =
    React.useState(false)

  const onAttrChange = <K extends keyof LevelingEmbed>(
    newValue: LevelingEmbed[K],
    attr: K
  ) =>
    onEmbedChange?.((embed) => {
      if (embed.type !== 'leveling') return embed
      return { ...embed, [attr]: newValue }
    })

  return (
    <div className="poe-skills-group">
      <TabsBox
        tabs={[
          {
            selector: (
              <span className="poe-skills-header-item">
                <span>Full Gem List</span>
                <span>Level {skillsStep?.level || 1}</span>
              </span>
            ),
            content: (
              <div className="poe-skills-group-skills">
                {activeSkills?.embed && (
                  <WithStore store={activeSkills.store}>
                    <SkillGems
                      steps={activeSkills.embed.steps}
                      active={activeSkills.active ?? activeSkills.embed.step}
                    />
                  </WithStore>
                )}
              </div>
            )
          },
          ...(!!onEmbedChange ||
          (embed.skillGemsDescription?.root?.children?.length ?? 0) > 1 // if it has more children, presume it's not empty
            ? [
                {
                  selector: (
                    <span className="poe-skills-header-item">
                      Skill Gems Description
                      {!!onEmbedChange && (
                        <span>
                          {isEditingSkillGemsDesc ? (
                            <button
                              onClick={() => setIsEditingSkillGemsDesc(false)}>
                              Close
                            </button>
                          ) : (
                            <FontAwesomeIcon
                              icon={faEdit}
                              onClick={() => {
                                setIsEditingSkillGemsDesc(
                                  !isEditingSkillGemsDesc
                                )
                              }}
                            />
                          )}
                        </span>
                      )}
                    </span>
                  ),
                  content: (
                    <div className="skill-gems-description">
                      <RichTextEditor
                        render={true}
                        key={`${embed.id}-skillGemsDescription-content`}
                        value={embed?.skillGemsDescription}
                        isEditing={isEditingSkillGemsDesc}
                        onChange={
                          onEmbedChange
                            ? (newValue) => {
                                onAttrChange(newValue, 'skillGemsDescription')
                              }
                            : undefined
                        }
                      />
                    </div>
                  )
                }
              ]
            : [])
        ]}
        headerSpacing={{ type: 'equal-spacing' }}
        className="poe-skill-tabs"
      />
    </div>
  )
}
